// third-party
import { combineReducers } from '@reduxjs/toolkit';

// project imports
import menu from './slices/menu';
import auth from './slices/auth';
import census from './slices/census';
import hospital from './slices/hospital';
import hospitalAdmin from './slices/hospital-admin';
import hospitalTiering from './slices/hospital-tiering';
import patients from './slices/patients';
import profile from './slices/profile';
import unitFloorRoomMapping from './slices/unit-floor-room-mapping';
import userAdmin from './slices/user-admin';
import handoff from './slices/handoff';
import notifications from './slices/notifications';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    menu,
    auth,
    census,
    hospital,
    hospitalAdmin,
    hospitalTiering,
    patients,
    profile,
    unitFloorRoomMapping,
    userAdmin,
    handoff,
    notifications
});

export default reducer;
